export default "__VITE_ASSET__Baznx3L___"